/* eslint-disable no-useless-escape */
import React from 'react';
export function UtagScript() {
  return (
    <script
      defer
      className="utag-script"
      type={"text/javascript"}
      suppressHydrationWarning
      src={"/NextAssets/scripts/utag-script.js"}
    />
  );
}
